import { createContext } from "react";
import { money } from "@/lib/api";

export const UsdOnly = createContext(false);
export const usePrice = () => money;
export const Usd = () => null;
export const UsdOnlyNote = () => null;
export const AudNote = ({ className = "", testId = "currency-note" }) => <p data-testid={testId} className={`text-xs ${className}`}>Prices and charges are in <b>US dollars (USD)</b>.</p>;
